import { render, staticRenderFns } from "./SnotifyIcon.vue?vue&type=template&id=7ce7008c"
import script from "./SnotifyIcon.vue?vue&type=script&lang=js"
export * from "./SnotifyIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports